import { render } from "./KundenkontoNavigation.vue?vue&type=template&id=0a4b1826&ts=true"
import script from "./KundenkontoNavigation.vue?vue&type=script&lang=ts"
export * from "./KundenkontoNavigation.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./KundenkontoNavigation.vue?vue&type=style&index=0&id=0a4b1826&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/builds/obi-dbs/smarttech_dbs_self-service/self-service/self-components/web-components/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__